<template>
  <div @click="closeNav">
    <v-app id="inspire">
      <vue-headful :title="'GS1 Georgia'" />
      <v-navigation-drawer
        v-model="drawer"
        enable-route-watcher
        app
        enable-resize-watcher
        :iconName="'my_icon'"
      >
        <div class="drawer-header-line primary">
          <router-link to="/manager" class="drawer-logo-link">
            <v-img
              v-if="useMainLogo"
              src="@/assets/img/gs1_logo.png"
              max-height="40"
              max-width="75"
              contain
            ></v-img>
            <v-img
              v-else
              src="@/assets/img/sol2.png"
              max-height="40"
              max-width="45"
              contain
            ></v-img>
          </router-link>
        </div>
        <NavigationList />
      </v-navigation-drawer>

      <v-app-bar app color="primary" dark>
        <v-row fluid>
          <v-col lg="10">
            <v-app-bar-nav-icon
              class="float-left"
              @click.stop="drawer = !drawer"
            />
          </v-col>
          <v-col lg="2">
            <LanguageChange class="float-right" />
          </v-col>
        </v-row>
      </v-app-bar>

      <router-view class="pa-5"></router-view>
      <AiGenerator />

      <v-footer color="primary" app>
        <span class="white--text">&copy; {{currentYear}} GS1 Georgia</span>
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import NavigationList from "@/components/manager/Navigation";
import LanguageChange from "@/components/shared/Language";
import AiGenerator from "@/components/manager/popup/AiGenerator";
export default {
  props: {
    source: String,
  },
  components: {
    NavigationList,
    LanguageChange,
    AiGenerator,
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
  computed: {
    useMainLogo() {
      return (
        this.$route.meta.provider != "solution" ||
        this.$route.params.type == "membership"
      );
    },
  },
};
</script>

<style scoped>
.drawer-header-line {
  height: 64px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  position: relative;
  z-index: 1;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2),
    0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.drawer-logo-link {
  display: inline-flex;
  align-items: center;
  text-decoration: none;
}

@media (max-width: 959px) {
  .drawer-header-line {
    height: 56px;
  }
}
</style>
